import { all, fork, put, takeLatest, call, takeEvery } from 'redux-saga/effects';
import {
    getTotalNoSurcharges as getTotalNoSurchargesApi,
    getTotalNoNonShipmentSurcharges as getTotalNoNonShipmentSurchargesApi,
    getTotalSurchargesCost as getTotalSurchargesCostApi,
    getTotalNonShipmentSurchargesCost as getTotalNonShipmentSurchargesCostApi,
    getSurchargeSummary as getSurchargeSummaryApi,
    getNonShipmentSurchargeSummary as getNonShipmentSurchargeSummaryApi,
    getSurchargesByTimeframe as getSurchargesByTimeframeApi,
} from '../../helpers';
import { surchargesKpisApiResponseSuccess, surchargesKpisApiResponseError, } from './actions';
import { SurchargesKpisActionTypes } from './constants';
import { nonShipmentSurchargeSummaryResponseToNonShipmentSurchargeSummaryObject } from '../../helpers/mappers/nonShipmentSurchargeSummary';
import { addToast } from '../actions';

function* getTotalNoSurcharges({ payload: { query } }) {
    try {
        const getTotalNoSurchargesResponse = yield call(getTotalNoSurchargesApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES, getTotalNoSurchargesResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES, error));
    }
}

function* getTotalNoNonShipmentSurcharges({ payload: { query } }) {
    try {
        const getTotalNoNonShipmentSurchargesResponse = yield call(getTotalNoNonShipmentSurchargesApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES, getTotalNoNonShipmentSurchargesResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES, error));
    }
}

function* getTotalSurchargesCost({ payload: { query } }) {
    try {
        const getTotalSurchargesCostResponse = yield call(getTotalSurchargesCostApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST, getTotalSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST, error));
    }
}

function* getTotalNonShipmentSurchargesCost({ payload: { query } }) {
    try {
        const getTotalNonShipmentSurchargesCostResponse = yield call(getTotalNonShipmentSurchargesCostApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST, getTotalNonShipmentSurchargesCostResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST, error));
    }
}

function* getSurchargeSummary({ payload: { query } }) {
    try {
        const getSurchargeSummaryResponse = yield call(getSurchargeSummaryApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY, getSurchargeSummaryResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY, error));
    }
}

function* getNonShipmentSurchargeSummary({ payload: { query } }) {
    try {
        const getNonShipmentSurchargeSummaryResponse = yield call(getNonShipmentSurchargeSummaryApi, query);
        const nonShipmentSurchargeSummary = getNonShipmentSurchargeSummaryResponse.data.map((nonShipmentSurchargeSummaryResponse) =>
            nonShipmentSurchargeSummaryResponseToNonShipmentSurchargeSummaryObject(nonShipmentSurchargeSummaryResponse)
        );
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY, nonShipmentSurchargeSummary));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY, error));
    }
}

function* getSurchargesByTimeframe({ payload: { query } }) {
    try {
        const getSurchargesByTimeframeResponse = yield call(getSurchargesByTimeframeApi, query);
        yield put(surchargesKpisApiResponseSuccess(SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME, getSurchargesByTimeframeResponse.data));
    } catch (error) {
        yield put(addToast({ desc: error?.errors?.[0]?.message, type: 'error' }));
        yield put(surchargesKpisApiResponseError(SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME, error));
    }
}

export function* watchGetTotalNoSurcharges(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_TOTAL_NO_SURCHARGES, getTotalNoSurcharges);
}

export function* watchGetTotalNoNonShipmentSurcharges(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_TOTAL_NO_NON_SHIPMENT_SURCHARGES, getTotalNoNonShipmentSurcharges);
}

export function* watchGetTotalSurchargesCost(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_TOTAL_SURCHARGES_COST, getTotalSurchargesCost);
}

export function* watchGetTotalNonShipmentSurchargesCost(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_TOTAL_NON_SHIPMENT_SURCHARGES_COST, getTotalNonShipmentSurchargesCost);
}

export function* watchGetSurchargeSummary(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_SURCHARGE_SUMMARY, getSurchargeSummary);
}

export function* watchGetNonShipmentSurchargeSummary(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_NON_SHIPMENT_SURCHARGE_SUMMARY, getNonShipmentSurchargeSummary);
}

export function* watchGetSurchargesByTimeframe(): any {
    yield takeLatest(SurchargesKpisActionTypes.GET_SURCHARGES_BY_TIMEFRAME, getSurchargesByTimeframe);
}

function* surchargesKpisSaga() {
    yield all([
        fork(watchGetTotalNoSurcharges),
        fork(watchGetTotalNoNonShipmentSurcharges),
        fork(watchGetTotalSurchargesCost),
        fork(watchGetTotalNonShipmentSurchargesCost),
        fork(watchGetSurchargeSummary),
        fork(watchGetNonShipmentSurchargeSummary),
        fork(watchGetSurchargesByTimeframe),
    ]);
}

export default surchargesKpisSaga;
